import type { ReactElement } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import { OverlayScrollableContent } from "app/pages/sales-intelligence/common-components/filters-panel/components/ExpandedFiltersOverlay/OverlayScrollableContent";
import { CategorizedFiltersGrid } from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersList/CategorizedFiltersGrid";
import type { FiltersCategorizedGroup } from "app/pages/sales-intelligence/common-components/filters-panel/types/category";
import type { FilterCategory } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/category";
import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type { LeadsSearchAllFiltersTypes } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";

type GridItem = IFilterInstance<LeadsSearchAllFiltersTypes>;

type Props = {
    selectedCategory: FilterCategory;
    startScrolledPastPermanentFilters: boolean;
    permanentFilters: readonly GridItem[];
    groups: readonly FiltersCategorizedGroup<GridItem>[];
    renderFilterCard: (config: GridItem) => ReactElement;
};

export const TeamFiltersListPanel = ({
    selectedCategory,
    startScrolledPastPermanentFilters,
    permanentFilters,
    groups,
    renderFilterCard,
}: Props) => (
    <Stack
        flex="1"
        minWidth="0"
        minHeight="0"
    >
        <OverlayScrollableContent
            selectedCategory={selectedCategory}
            scrollToTop={selectedCategory === "all"}
            initialScrollCategoryId={startScrolledPastPermanentFilters ? groups[0]?.category.id : undefined}
        >
            <Stack
                flex="1"
                minWidth="0"
                data-automation="team-filters-list"
                margin="-16px 0 0 0"
            >
                <CategorizedFiltersGrid
                    permanentFilters={permanentFilters}
                    groups={groups}
                    renderFilterCard={renderFilterCard}
                />
            </Stack>
        </OverlayScrollableContent>
    </Stack>
);
